"use strict";

import $ from "jquery";

if (
  $(".path-search .pager").length &&
  !$($(".pager__item")[1]).hasClass("is-active")
) {
  $(".map-result").hide();
}

if ($("body").hasClass("path-recommendations") || $("body").hasClass("path-implementation-and-progress") || $("body").hasClass("path-_021-australian-infrastructure-plan-implementation-and-progress")) {
  if(!$.trim($(".views-element-container .view-content").html())) {
    $(".views-element-container .view-content").html('<div class="no-result-found">No results found<div>');
  }
  $("#edit-search-api-fulltext--2").after(
    "<div class='terms-containers'></div>"
  );
  $("#edit-search-api-fulltext--2").attr("autocomplete", "off");

  let terms;
  $.getJSON("ip-terms-json", function (data) {
    terms = data.map((item) => item.name);
    terms.sort();
  }).fail(function () {
    console.log("An error has occurred.");
  });

  $("#edit-search-api-fulltext--2").on("input", function (e) {
    let text = $(this).val();
    if(text == '') {
      $(".terms-containers").hide();
      return false;
    }
    let curTerms = terms.filter((item) => item.toLowerCase().includes(text.toLowerCase()));
    if (curTerms.length === 0) {
      $(".terms-containers").html();
      $(".terms-containers").hide();
      return false;
    }
    curTerms.slice(0, 5);
    let dropdownHtml = "";
    dropdownHtml += "<ul>";
    curTerms.forEach((item) => {
      let itemHtml = item.replace(new RegExp(text, "gi"), match => `<span class="highlight">${match}</span>`);
      dropdownHtml += `<li>${itemHtml}</li>`;
    });
    dropdownHtml += "</ul>";
    $(".terms-containers").html(dropdownHtml);
    $(".terms-containers").show();

    $(".terms-containers li").on("mousedown", function (e) {
      $("#edit-search-api-fulltext--2").val($(this).text());
    });
  });

  $("#edit-search-api-fulltext--2").on("blur", function (e) {
    $(".terms-containers").hide();
  });
}
